<template>
  <div>
    <div class="row">
      <div class="row page-title">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
        <div class="col-md-11">
          <h4><u>Αδράνειες</u></h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="flex-container">
        <div class="row">
          <div class="col-md-offset-2 col-md-4">
            <button
              class="invert"
              id="btnOrganizationVacations"
              v-if="isAdmin || isSuperAdmin"
              @click="showOrganizationVacations"
            >
              Αδράνειες Φορέα
            </button>
          </div>
          <div class="col-md-4">
            <button
              class="invert"
              id="btnStructureVacations"
              v-if="isAdmin || isSuperAdmin"
              @click="showStructureVacations"
            >
              Αδράνειες Δομών
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import BackButton from "../../components/shared/backButton";

export default {
  components: {
    BackButton,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  methods: {
    showStructureVacations() {
      router.replace("/structureVacations");
    },
    showOrganizationVacations() {
      router.replace("/organizationVacations");
    },
  },
};
</script>
